import {mobileConstants} from "../../constants";

const initialState = {
    data: null,
    status: [],
    select: [],
    prev:{},
    next:{},
    isCalled: false,
    isLoading: false,
    isFailure: false,
    selectSeq: null,
    count: 0,

}

export default function mobile(state = initialState, action){
    switch (action.type){

        /******
         리스트
         *****/
        case mobileConstants.LOAD_REQUEST:
            return{
                ...state,
                isLoading: !state.isLoading,
            }
        case mobileConstants.LOAD_SUCCESS:
            return{
                ...state,
                data: action.response.data.payload
            }
        case mobileConstants.LOAD_FAILURE:
            return{
                ...state,
                isLoading: false,
                isFailure: true,
            }

        /*******
         선택
          *******/

        case mobileConstants.SELECT_REQUEST:

            window.open('/canvasNew/composeViewer_new.htm?menuId=104&cntrctNo='+action.params,'_blank')

            return{
                ...state,
                isLoading: !state.isLoading,
            }

        /******
         알림 건수 조회
         *****/
        case mobileConstants.COUNT_REQUEST:
            return{
                ...state,
                isLoading: !state.isLoading,
            }
        case mobileConstants.COUNT_SUCCESS:
            return{
                ...state,
                count: action.response.data.payload
            }
        case mobileConstants.COUNT_FAILURE:
            return{
                ...state,
                isLoading: false,
                isFailure: true,
            }

        /******
         삭제
         *****/
        case mobileConstants.DELETE_REQUEST:
            return{
                ...state,
                isCalled: false,
            }
        case mobileConstants.DELETE_SUCCESS:
            console.log(action.response.data.payload);
            return{
                ...state,
                isCalled: true,
            }
        case mobileConstants.DELETE_FAILURE:
            return{
                isCalled: true,
                isFailure: true,
            }

        default:
            return state
    }
}